import { gql } from "@apollo/client"
import {
  InitializeEsignatureAuthorizationInput,
  InitializeEsignatureAuthorizationPayload,
} from "@oysterhr/schema"
import { useMutation, InjectedOptions } from "@oysterhr/core"

export const PAYMENTS_COMPANY_INITIALIZE_E_SIGNATURE_AUTHORIZATION = gql`
  mutation PaymentsCompanyInitializeEsignatureAuthorization($paymentMethodId: ID!) {
    initializeEsignatureAuthorization(input: { paymentMethodId: $paymentMethodId }) {
      redirectUrl
      errors
    }
  }
`

const useInitializeEsignatureAuthorization = (
  options: InjectedOptions<
    { initializeEsignatureAuthorization: InitializeEsignatureAuthorizationPayload },
    InitializeEsignatureAuthorizationInput
  >,
) =>
  useMutation<
    { initializeEsignatureAuthorization: InitializeEsignatureAuthorizationPayload },
    InitializeEsignatureAuthorizationInput
  >(PAYMENTS_COMPANY_INITIALIZE_E_SIGNATURE_AUTHORIZATION, options)

export default () => {
  const [initializeEsignatureAuthorization] = useInitializeEsignatureAuthorization({
    analyticsEventName: "initialize_esignature_authorization",
    handlePayloadErrors: true,
  })

  return { initializeEsignatureAuthorization }
}
